import { useEffect, useState } from "react";
import { Card, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { H4, H6, P } from "../../../AbstractElements";
import { useStaf } from "../../../Context/StafContext";

const ModalDetailStaf = ({ row, stafList }) => {
  const stafAPI = useStaf();
  const [detailOpen, setDetailOpen] = useState(null);
  const [fotoURL, setFotoURL] = useState();
  const [statusStafOptions, setStatusStafOptions] = useState();
  // const [tipeStafOptions, setTipeStafOptions] = useState();
  const [groupStafOptions, setGroupStafOptions] = useState();
  const [atasanOptions, setAtasanOptions] = useState();
  const [usernameLDAP, setUsernameLDAP] = useState();
  const toggleDetail = (id) => setDetailOpen(detailOpen === id ? null : id);
  // const axiosInstance = useAxios();

  useEffect(() => {
    if (detailOpen === row?.id) {
      fotoProfil();
      StatusStaf();
      // TipeStaf();
      GroupStaf();
      Atasan();
      checkUsername();
    }
  }, [detailOpen, stafList]);

  const fotoProfil = () => {
    if (row?.foto_id) {
      stafAPI.getFotoProfilByID(row?.foto_id).then((res) => {
        const url = URL.createObjectURL(res.data);
        setFotoURL(url);
      });
    }
  };

  const StatusStaf = async () => {
    stafAPI.getStatusStaf().then((res) => {
      const statusStaf = res.data.map((staf) => ({
        id: staf.id_status_staf,
        name: staf.nama_status_staf,
      }));
      setStatusStafOptions(statusStaf);
    });
  };

  // const TipeStaf = async () => {
  //   getTipeStaf(axiosInstance).then((res) => {
  //     const tipeStaf = res.data.map((staf) => ({
  //       id: staf.id_tipe_staf,
  //       name: staf.nama_tipe_staf,
  //     }));
  //     setTipeStafOptions(tipeStaf);
  //   });
  // };

  const GroupStaf = async () => {
    stafAPI.getGroupStaf().then((res) => {
      const groupStaf = res.data.map((staf) => ({
        id: staf.id_group,
        name: staf.nama,
      }));
      setGroupStafOptions(groupStaf);
    });
  };

  const Atasan = async () => {
    const atasan = stafList?.map((staf) => ({
      id: staf.id,
      name: staf.nama,
    }));
    setAtasanOptions(atasan);
  };

  const checkUsername = () => {
    const form = {
      username: row?.username_ldap,
    };
    stafAPI.checkUsernameLDAP(form).then((res) => {
      setUsernameLDAP(res.data.available);
    });
  };

  function findStatusById(id) {
    const status = statusStafOptions?.find((status) => status.id === id);
    return status?.name || "-";
  }

  // function findTipeById(id) {
  //   const tipe = tipeStafOptions?.find((tipe) => tipe.id === id);
  //   return tipe?.name || "-";
  // }

  function findGroupById(id) {
    const group = groupStafOptions?.find((group) => group.id === id);
    return group?.name || "-";
  }

  function findAtasanById(id) {
    if (!atasanOptions) {
      return "Memuat";
    }

    const atasan = atasanOptions?.find((atasan) => atasan.id === id);
    return atasan?.name || "-";
  }

  return (
    <>
      <a
        href="#"
        onClick={(e) => {
          toggleDetail(row?.id);
          e.preventDefault();
        }}
      >
        {row?.nama}
      </a>

      <Modal
        isOpen={detailOpen === row?.id}
        toggle={() => toggleDetail(row?.id)}
        size="lg"
      >
        <ModalHeader toggle={() => toggleDetail(row?.id)}>
          Detail Staf
        </ModalHeader>
        <ModalBody>
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col className="d-flex justify-content-center">
              <Card
                style={{
                  width: "10rem",
                  height: "12rem",
                  border: "1px solid #d1d1d1",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                }}
              >
                {fotoURL ? (
                  <img
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "cover",
                    }}
                    alt="foto profil"
                    src={fotoURL}
                  />
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 120"
                    style={{
                      width: "80%",
                      height: "80%",
                    }}
                  >
                    <rect width="100" height="120" fill="#e3e3e3" />
                    <circle cx="50" cy="40" r="25" fill="#a0aec0" />
                    <path
                      d="M50 70 C25 70 15 90 15 120 L85 120 C85 90 75 70 50 70"
                      fill="#a0aec0"
                    />
                    <circle
                      cx="50"
                      cy="35"
                      r="12"
                      fill="#e3e3e3"
                      opacity="0.2"
                    />
                    <path
                      d="M50 75 C30 75 20 90 20 120 L80 120 C80 90 70 75 50 75"
                      fill="#98a5b3"
                    />
                  </svg>
                )}
              </Card>
            </Col>
            <Col>
              <H6>Nama</H6>
              <P>{row?.nama}</P>
            </Col>
            <Col>
              <H6>Nickname</H6>
              <P>{row?.nickname || "-"}</P>
            </Col>
          </Row>
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>Inisial</H6>
              <P>{row?.inisial || "-"}</P>
            </Col>
            <Col>
              <H6>Username LDAP</H6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p className="mb-0">{row?.username_ldap || "-"}</p>
                {usernameLDAP && (
                  <span title="Username LDAP terverifikasi">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#22c55e"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </span>
                )}
              </div>
            </Col>
            <Col>
              <H6>Email Lain</H6>
              <P>{row?.email_lain || "-"}</P>
            </Col>
          </Row>
          <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>NIP</H6>
              <P>{row?.nip || "-"}</P>
            </Col>
            <Col>
              <H6>NUP UI</H6>
              <P>{row?.nup_ui || "-"}</P>
            </Col>
            <Col>
              <H6>Golongan PNS</H6>
              <P>{row?.golongan_pns || "-"}</P>
            </Col>
          </Row>
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>Ruangan</H6>
              <P>{row?.ruangan || "-"}</P>
            </Col>
            <Col>
              <H6>Ext. Telpon</H6>
              <P>{row?.ext_telp || "-"}</P>
            </Col>
            <Col>
              <H6>Telpon</H6>
              <P>{row?.telp || "-"}</P>
            </Col>
          </Row>
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>ID Finger</H6>
              <P>{row?.id_finger || "-"}</P>
            </Col>
          </Row>
          <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
          <Row className={"my-4"} xl="2" xs="1">
            <Col>
              <H6>Status Staf</H6>
              <P>{findStatusById(row?.status_staf)}</P>
            </Col>
            {/* <Col>
              <H6>Tipe Staf</H6>
              <P>{findTipeById(row?.tipe_staf)}</P>
            </Col> */}
            <Col>
              <H6>Group Staf</H6>
              <P>{findGroupById(row?.group_staf)}</P>
            </Col>
          </Row>
          <Row className={"my-4"} xl="2" xs="1">
            <Col>
              <H6>Atasan 1</H6>
              <P>{findAtasanById(row?.atasan_1_id)}</P>
            </Col>
            {/* <Col>
              <H6>Atasan 2</H6>
              <P>{findAtasanById(row?.atasan_2_id)}</P>
            </Col> */}
          </Row>
          <hr style={{ margin: "40px 0", height: "1", color: "#d1d1d1" }} />
          <H4>Kontak Darurat</H4>
          <br />
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>Nama</H6>
              <P>{row?.nama_kontak_darurat}</P>
            </Col>
            <Col>
              <H6>Hubungan</H6>
              <P>{row?.hubungan_kontak_darurat}</P>
            </Col>
          </Row>
          <Row className={"my-4"} xl="3" sm="2" xs="1">
            <Col>
              <H6>Alamat</H6>
              <P>{row?.alamat_kontak_darurat}</P>
            </Col>
            <Col>
              <H6>Telpon/HP</H6>
              <P>{row?.telpon_kontak_darurat}</P>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ModalDetailStaf;
